export const state = () => ({
  jumbotron: null
});

export const mutations = {
  CLEAR_JUMBOTRON (state) {
    state.jumbotron = null;
  },
  SET_JUMBOTRON (state, payload) {
    state.jumbotron = payload;
  }
};

export const getters = {
  getJumbotron (state) {
    return state.jumbotron;
  }
};
